import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  padding: 1rem 0;
`;

export const Paragraph = styled.p`
  margin-bottom: 1.5rem;
  text-align: left;
`;

export const WatchdogWrapper = styled.div`
  text-align: left;
`;

export const ErrorText = styled.span`
  margin-left: 1.2rem;
  line-height: 2.8125rem;
  color: ${(props) => props.theme.palette.danger};
  cursor: help;
`;

export const Buttons = styled.div`
  margin-top: 1.25rem;
  max-height: 2.8125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
